/* globals __TEST__ */
import ko from "knockout";
import { getDecodedQueryParamsFromWindow } from "util/uriUtil";

const authToken = ko.observable();

function updateConfig() {
    const params = getDecodedQueryParamsFromWindow();
    authToken(params.authToken);
}

if (!__TEST__) {
    window.addEventListener("hashchange", updateConfig);
    updateConfig();
}

export default {
    authToken: ko.pureComputed(() => authToken()),
};
